import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TouchableOpacity, View } from 'react-native';

import NavigationArrow from '../navigation-arrow';
import Text from '../text';
import styles from './pagination.styles';
import { createContainer } from '@dbk-legacy/muster/react';

class Pagination extends PureComponent {
  constructor() {
    super();
    this.handlePrevPage = this.handlePrevPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
  }
  handlePrevPage() {
    let assetPageSize = this.props.app.config.assetPageSize;
    let newOffset = this.props.pageOffset - assetPageSize;
    if (newOffset < 0) newOffset = 0;
    this.props.setPageOffset(newOffset);
    this.props.onPageChange();
  }

  handleNextPage() {
    let assetPageSize = this.props.app.config.assetPageSize;
    const newOffset = this.props.pageOffset + assetPageSize;
    this.props.setPageOffset(newOffset);
    this.props.onPageChange();
  }

  gotoPage(pageIndex) {
    let assetPageSize = this.props.app.config.assetPageSize;
    const newOffset = pageIndex * assetPageSize;
    this.props.setPageOffset(newOffset);
    this.props.onPageChange();
  }

  render() {
    const { pageOffset, pageSize, totalRecords, style, i18n: {messages},app:{config:{assetPageSize}}} = this.props;
    const hasPrevPage = pageOffset > 0;
    const hasNextPage = pageOffset + pageSize < totalRecords;

    if (!hasPrevPage && !hasNextPage) {
      return null;
    }

    const containerStyles = [styles.root];
    if (style) containerStyles.push(style);

    const currentPage = Math.floor(pageOffset / assetPageSize);
    const maxPage = Math.ceil(totalRecords / assetPageSize) - 1;

    let startPage = (currentPage - 2 > 0 ? currentPage - 2 : 0);
    let endPage = (currentPage + 2 <= maxPage ? currentPage + 2 : maxPage);
    endPage = startPage + 3 > endPage && startPage + 3 <= maxPage ? startPage + 3 : endPage;
    startPage = endPage - 3 < startPage && endPage - 3 >= 0 ? endPage - 3 : startPage;

    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <View style={containerStyles}>
        <TouchableOpacity
          disabled={!hasPrevPage}
          onPress={this.handlePrevPage}
          style={[
            styles.button,
            styles.buttonPrev,
            !hasPrevPage && styles.buttonDisabled,
          ]}
        >
          <NavigationArrow
            color="secondary"
            size="normal"
            thickness="thin"
            direction="left"
            disabled={!hasPrevPage}
          />
          <Text style={[
            styles.textPrev,
            !hasPrevPage && styles.textDisabled
          ]}>{messages['app.pagination.prev']}</Text>
        </TouchableOpacity>
        {
          startPage > 0 && <Text style={styles.pageMore}>...</Text>
        }
        {
          pageNumbers.map(no => {
            return (
              <TouchableOpacity
                key={no}
                onPress={() => this.gotoPage(no)}
                disabled={currentPage == no}
                style={[
                  styles.button,
                  styles.buttonNumber,
                  currentPage == no && styles.buttonActive,
                ]}
              >
                <Text style={[
                  currentPage == no && styles.textActive,
                ]}>{no + 1}</Text>
              </TouchableOpacity>
            );
          })
        }
        {
          endPage < maxPage && <Text style={styles.pageMore}>...</Text>
        }
        <TouchableOpacity
          disabled={!hasNextPage}
          onPress={this.handleNextPage}
          style={[
            styles.button,
            styles.buttonNext,
            !hasNextPage && styles.buttonDisabled,
          ]}
        >
          <Text style={[
            styles.textNext,
            !hasNextPage && styles.textDisabled,
          ]}>{messages['app.pagination.next']}</Text>
          <NavigationArrow
            color="secondary"
            size="normal"
            thickness="thin"
            direction="right"
            disabled={!hasNextPage}
          />
        </TouchableOpacity>
      </View>
    );
  }
}

Pagination.propTypes = {
  pageOffset: PropTypes.number,
  pageSize: PropTypes.number,
  totalRecords: PropTypes.number,
  setPageOffset: PropTypes.func,
  onPageChange: PropTypes.func,
};


export default createContainer({
  $queries: {
    app: {
      config:{
        assetPageSize:true,
      }
    },
    i18n: {
      messages: true
    }
  },
})(Pagination);
